export default "__VITE_ASSET__CnKF4qgj__"